import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { WorkoutProgramDetailComponent } from 'src/app/main/home/workout-programs/workout-program-detail/workout-program-detail.component';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-quiz-select-program',
  templateUrl: './quiz-select-program.component.html',
  styleUrls: ['./quiz-select-program.component.scss']
})
export class QuizSelectProgramComponent implements OnInit {
  currentStep = 0;
  result = [];
  answers: string[] = [];
  steps: { question: string; options: string[] }[] = [];
  selectedOptKey = null;
  suggestedPrograms = [];
  selectedProgramIndex = null;
  environment = environment.baseURL.workout_programs;
  spinner: boolean = false;

  constructor(public translate: TranslateService, public guiService: GuiService, private restService: RestService) {

  }

  ngOnInit(): void {
    this.guiService.showSpinner = false;
    this.steps = this.loadSteps();
  }

  ionViewWillLeave() {
    console.debug('will leave')
    this.currentStep = 0;
    this.answers = [];
    this.result = [];
    this.selectedOptKey = null;
  }

  ionViewWillEnter() {
    console.debug('will enter')
    this.currentStep = 0;
    this.answers = [];
    this.result = [];
    this.selectedOptKey = null;
  }

  loadSteps(): { question: string; options: string[] }[] {
    return [
      {
        question: 'LOGIN.QUIZ.question_1', // Livello
        options: ['question_1_option_1', 'question_1_option_2', 'question_1_option_3'],
      },
      {
        question: 'LOGIN.QUIZ.question_2', // Obiettivo
        options: ['question_2_option_1', 'question_2_option_2', 'question_2_option_3', 'question_2_option_4'],
      },
      {
        question: 'LOGIN.QUIZ.question_3', // Dove
        options: ['question_3_option_1', 'question_3_option_2'],
      },
      {
        question: 'LOGIN.QUIZ.question_4', // Frequenza
        options: ['question_4_option_1', 'question_4_option_2'],
      },
      {
        question: 'LOGIN.QUIZ.question_5', // Durata
        options: ['question_5_option_1', 'question_5_option_2', 'question_5_option_3'],
      },
      {
        question: 'LOGIN.QUIZ.question_6', // Hai partorito?
        options: ['question_6_option_1', 'question_6_option_2'],
      },
      {
        question: 'LOGIN.QUIZ.question_7', // Da quanto tempo hai partorito?
        options: ['question_7_option_1', 'question_7_option_2', 'question_7_option_3'],
      }
    ];
  }


  selectOption(optionKey: string) {
    this.answers[this.currentStep] = optionKey;
    this.answers = this.answers.slice(0, this.currentStep + 1);

    const step = this.currentStep;
    const isHome = this.answers[2] === 'question_3_option_1';
    const isGym = this.answers[2] === 'question_3_option_2';
    const freq = this.answers[3];
    const durata = this.answers[4];
    const partoNoKey = 'question_6_option_2';

    // logica per ramificazione dinamica
    if (step === 4) {
      if (durata === 'question_5_option_1' && freq === 'question_4_option_1') {
        this.currentStep++; // 5 (parto)
      } else if (durata === 'question_5_option_1' && freq === 'question_4_option_2') {
        this.currentStep++; // 5 (parto)
      } else {
        this.currentStep++; // 5 (parto)
      }
      return;
    }

    if (step === 5 && optionKey === partoNoKey) {
      this.answers[6] = 'N/A';
      this.currentStep += 2;
    } else {
      this.currentStep++;
    }

    if (this.currentStep >= this.steps.length) {
      this.showResult();
    }

    this.selectedOptKey = null;
  }

  goBack() {
    if (this.currentStep === 7 && this.answers[5] === 'question_6_option_2') {
      this.currentStep = 5;
    } else {
      this.currentStep--;
    }
    this.answers = this.answers.slice(0, this.currentStep + 1);
    this.result = [];
  }



  showResult() {
    const [livello, obiettivo, luogo, frequenza, durata, parto, tempo] = this.answers;

    const isPostpartum = parto === 'question_6_option_1';
    const isPostRecupero = tempo === 'question_7_option_3';

    const isHome = luogo === 'question_3_option_1';
    const isGym = luogo === 'question_3_option_2';

    if (isPostpartum) {
      if (!isPostRecupero) {
        this.result = ['Stronger Postpartum'];
        this.suggestedPrograms = this.result.map((name) =>
          this.guiService.programs.find(
            (x) => x.i18nName.IT.toLowerCase() === name.toLowerCase()
          )
        );
        return;
      }
    }

    if (isHome) {
      if (frequenza === 'question_4_option_1') {
        if (durata === 'question_5_option_1') this.result = ['Stronger Busy'];
        else if (durata === 'question_5_option_2') this.result = ['Stronger Full Body'];
      } else if (frequenza === 'question_4_option_2') {
        if (durata === 'question_5_option_1') this.result = ['Stronger Busy'];
        else if (durata === 'question_5_option_2') this.result = ['Stronger Full Body'];
        else if (durata === 'question_5_option_3') this.result = ['Stronger', 'Stronger booty'];
      }
    } else if (isGym) {
      if (frequenza === 'question_4_option_1') {
        if (durata === 'question_5_option_1') this.result = ['Stronger Busy'];
        else if (durata === 'question_5_option_2') this.result = ['Stronger Full Body'];
      } else if (frequenza === 'question_4_option_2') {
        if (durata === 'question_5_option_1') this.result = ['Stronger Busy'];
        else if (durata === 'question_5_option_2') this.result = ['Stronger Full Body'];
        else if (durata === 'question_5_option_3') this.result = ['Stronger Gym', 'Stronger booty'];
      }
    }

    this.suggestedPrograms = this.result.map((name) =>
      this.guiService.programs.find(
        (x) => x.i18nName.IT.toLowerCase() === name.toLowerCase()
      )
    );
  }

  getFilteredOptions(): string[] {
    // passo corrente
    const step = this.currentStep;

    // prendo tutte le opzioni per lo step
    let options = this.steps[step].options;

    // caso specifico: domanda 5 (index 4), dipende da risposta a domanda 4 (index 3)
    if (step === 4) {
      const answerQ4 = this.answers[3];
      if (answerQ4 === 'question_4_option_1') { // 3 volte a settimana
        // filtro fuori '60 minuti' (question_5_option_3)
        options = options.filter(opt => opt !== 'question_5_option_3');
      }
    }
    return options;
  }

  selectProgram(programId){
    const params = {
      userId: this.guiService.userLogged.user.id,
      currentProgram: programId
    }
    this.spinner = true;
    this.restService.postService('node', '/init-workout-program', params).subscribe((ris)=>{
      this.guiService.userLogged.workoutInfo = ris;
      this.spinner = false;
      this.guiService.goTo('main/home');
    })
  }

}
